import React from 'react'
import i18n from 'i18n-js'
import { useSelector, useDispatch } from 'react-redux'
import { ImCross } from 'react-icons/im'
import { updateBuildings } from '../../../store/actions/buildings'

import Select from '../../UI/Select/Select'

import './FlagsOverlay.scss'

const FlagsOverlay = props => {
    const buildings = useSelector(state => state.buildings)
    const overlayClasses = ['FlagsOverlay', props.active ? 'active' : '']
    const dispatch = useDispatch()

    const onSelectChange = (evt, id) => {
        dispatch(updateBuildings(parseInt(evt.target.value), id))
    }

    return <aside className={overlayClasses.join(' ')} role="dialog" aria-label={i18n.t('flags_overlay')}>
        <div className="dialog-content">
            <button type="button" className="close-overlay" aria-label={i18n.t('close_flags_dialog')} onClick={() => props.closeOverlay()}>
                <ImCross size="1.5em" />
            </button>
            <h2 className="pt-5 container">{i18n.t('flags_overlay_title')}</h2>
            <form className="container">
                {buildings && buildings.map(el => {
                    return <Select key={el.id} {...el} changed={evt => onSelectChange(evt, el.id)} />
                })}
            </form>
        </div>
    </aside>
}

export default FlagsOverlay